module.exports = __webpack_public_path__ + "static/media/velentine.ce139cad.jpg";